/* Schaufenster vor dem Konfigurator (Test 2026-09-17)

   Marc: Auf der Produktseite soll zuerst das Sofa in echten Wohnräumen
   stehen — ein Bild je Stofffarbe, bis zu zwanzig, jedes mit dem Namen
   seines Stoffs am Bild. Die beiden Konfigurationsschritte kommen erst nach
   „Jetzt konfigurieren".

   Der Weg hinein geht über zwei Türen: der große Knopf beginnt bei der Form,
   das Abzeichen am Bild springt direkt in die gezeigte Farbe. Die zweite Tür
   ist der Grund für die ganze Ansicht: Wer sich in ein Foto verliebt, will
   diese Farbe — nicht erst eine Farbliste.

   Eigene Datei, weil die Section an Shopifys Grenze von 256 KB je Vorlage
   stößt (ein Push darüber wird abgewiesen). Alles, was das Schaufenster vom
   Konfigurator braucht, kommt als `api` herein — es hält selbst keinen
   Zustand über Stoff, Farbe oder Preis. */

// Zehn (Marc, 2026-09-17): Mehr sieht sich niemand durch, und jedes weitere
// Bild kostet Ladezeit auf der wichtigsten Ansicht der Seite.
const MAX = 10;

export function erstelleSchaufenster(root, api) {
  const srEl = root.querySelector('[data-p3d-sr]');
  const bildEl = root.querySelector('[data-p3d-sr-bild]');
  const kachelEl = root.querySelector('[data-p3d-sr-kacheln]');
  let idx = 0;

  /* Ein Wohnbild je Farbe, Reihenfolge wie die Stoffliste im Shop.

     Nicht bestellbare Stoffe bleiben draußen: Ein Bild, das in den
     Konfigurator führt, muss dort auch zu einer Kombination führen — sonst
     endet der Sprung in einer Sackgasse. Mehrere Aufnahmen derselben Farbe
     fallen auf die erste zusammen; hier zählt die Vielfalt der Stoffe, nicht
     die Zahl der Fotos. */
  function sammle() {
    const k = api.holeKonfig();
    const wohn = ((k && k.bilder) || []).filter((b) => api.istWohnbild(b) && b.code);
    if (!wohn.length) return [];
    const raus = [];
    api.familien.filter(api.bestellbar).forEach((f) => f.colors.forEach((c) => {
      if (raus.length >= MAX) return;
      const b = wohn.find((x) => x.code === c.code);
      // Shopify liefert protokollrelativ; über http scheitert das still.
      if (b) raus.push({ ...b, farbe: c, u: b.u.replace(/^\/\//, location.protocol + '//') });
    }));
    return raus;
  }

  const liste = sammle();
  // Wohnbilder allein entscheiden, ob es ein Schaufenster gibt; das Video hängt hinten dran.
  const anzahlWohnbilder = liste.length;
  /* Produktionsvideo als letzte Kachel (Marc, 2026-10-12). Eigenes <video> über dem Bild;
     die Quelle kommt erst beim Anwählen, damit es die Fotos nicht ausbremst. */
  let videoEl = null;
  if (api.video && liste.length) {
    liste.push({ video: true, u: api.video.poster.replace(/^\/\//, location.protocol + '//') });
    videoEl = document.createElement('video');
    videoEl.className = 'fmnv-p3d__sr-bild fmnv-p3d__sr-video';
    videoEl.controls = true;
    videoEl.playsInline = true;
    videoEl.preload = 'none';
    videoEl.hidden = true;
    videoEl.setAttribute('aria-label', api.video.alt);
    bildEl?.insertAdjacentElement('afterend', videoEl);
    // Play-Icon mittig (Snippet fmnv_video-play); verschwindet beim ersten Abspielen.
    if (window.fmnvPlay) {
      const play = document.createElement('button');
      play.type = 'button';
      play.className = 'fmnv-play';
      play.setAttribute('aria-label', 'Video abspielen');
      play.innerHTML = window.fmnvPlay;
      videoEl.insertAdjacentElement('afterend', play);
      if (getComputedStyle(videoEl.parentElement).position === 'static') videoEl.parentElement.style.position = 'relative';
    }
  }

  const url = (b, breite) => (/width=\d+/.test(b.u)
    ? b.u.replace(/width=\d+/, 'width=' + breite)
    : b.u + (b.u.includes('?') ? '&' : '?') + 'width=' + breite);

  function zeigeBild(i, geklickt) {
    if (!liste.length || !bildEl) return;
    idx = (i + liste.length) % liste.length;
    const b = liste[idx];
    const badge = root.querySelector('[data-p3d-sr-badge]');
    if (videoEl) {
      if (b.video && !videoEl.src) { videoEl.poster = b.u; videoEl.src = api.video.src; }
      if (!b.video) videoEl.pause();
      videoEl.hidden = !b.video;
    }
    // Das Video zeigt keinen Stoff — kein Abzeichen, kein Einstieg in eine Farbe.
    if (badge) badge.hidden = !!b.video;
    const zaehlerV = root.querySelector('[data-p3d-sr-zaehler]');
    if (b.video) {
      if (zaehlerV) zaehlerV.textContent = `${idx + 1} / ${liste.length}`;
      markiereKachel(geklickt);
      return;
    }
    bildEl.src = url(b, 1400);
    bildEl.alt = `${api.produktTitel || 'Sofa'} im Stoff ${b.farbe.fam.name} ${b.farbe.label} — Wohnbild`;
    const probe = root.querySelector('[data-p3d-sr-probe]');
    if (probe) {
      probe.style.backgroundImage = b.farbe.swatch
        ? `url('${b.farbe.swatch.replace(/^\/\//, location.protocol + '//')}')` : '';
    }
    const famEl = root.querySelector('[data-p3d-sr-fam]');
    const nameEl = root.querySelector('[data-p3d-sr-name]');
    if (famEl) famEl.textContent = b.farbe.fam.name;
    if (nameEl) nameEl.textContent = b.farbe.label;
    if (badge) {
      badge.setAttribute('aria-label',
        `Sofa in ${b.farbe.fam.name} ${b.farbe.label} konfigurieren`);
    }
    if (zaehlerV) zaehlerV.textContent = `${idx + 1} / ${liste.length}`;
    markiereKachel(geklickt);
  }

  function markiereKachel(geklickt) {
    if (kachelEl) {
      [...kachelEl.children].forEach((el, n) => {
        el.classList.toggle('is-active', n === idx);
        el.setAttribute('aria-selected', String(n === idx));
      });
      /* Die Kachel des gezeigten Bildes in den Blick rollen — beim Blättern
         über Pfeile und Wischen läge sie sonst außerhalb der Reihe.
         `block: nearest` hält die Seite dabei still. */
      if (!geklickt) {
        kachelEl.children[idx]?.scrollIntoView(
          { block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }
  }

  function zeichneKacheln() {
    if (!kachelEl) return;
    kachelEl.textContent = '';
    liste.forEach((b, n) => {
      const k = document.createElement('button');
      k.type = 'button';
      k.className = 'fmnv-p3d__sr-kachel' + (b.video ? ' fmnv-p3d__sr-kachel--video' : '');
      k.setAttribute('role', 'tab');
      k.setAttribute('aria-selected', String(n === idx));
      k.setAttribute('aria-label', b.video ? 'Video ansehen: So entsteht dein Sofa' : `${b.farbe.fam.name} ${b.farbe.label} ansehen`);
      const img = document.createElement('img');
      img.src = url(b, 320);
      img.alt = '';
      img.decoding = 'async';
      // Die ersten vier stehen im Bild, der Rest kommt beim Wischen.
      if (n > 3) img.loading = 'lazy';
      const label = document.createElement('span');
      label.className = 'fmnv-p3d__sr-kachel-label';
      label.textContent = b.video ? 'Video' : b.farbe.label;
      k.append(img, label);
      k.addEventListener('click', () => {
        api.melde('konfigurator', 'schaufenster_kachel', b.video ? 'video' : b.farbe.label);
        zeigeBild(n, true);
      });
      kachelEl.appendChild(k);
    });
    // Pfeile an die Reihe, wenn sie weitergeht — dieselbe Mechanik wie bei
    // den Filterreihen im Stoffschritt.
    api.ruesteWischreihe(kachelEl);
  }

  /* Die Tür in den Konfigurator.

     Mit Farbe (Abzeichen am Bild): Stoff und Farbe stehen damit fest, also
     öffnet Schritt 2 und der Warenkorb ist frei — der Kunde hat seine Wahl am
     Foto getroffen, nicht an einer Liste. Ohne Farbe (der große Knopf):
     Schritt 1, wie bisher. */
  function oeffne(c, quelle) {
    videoEl?.pause();
    schliesseLeiste();
    api.setzeAktiv(false);
    root.classList.remove('ist-showroom');
    if (srEl) srEl.hidden = true;
    api.melde('konfigurator', 'schaufenster_start', quelle || '');
    // Jetzt erst das Modell holen — im Schaufenster hätte es den Fotos nur
    // Bandbreite genommen.
    api.modellLaden();
    if (c) { api.selectColor(c); api.unlockFabrics(); }
    else if (api.formGewaehlt && api.formGewaehlt()) api.unlockFabrics();
    else api.openStep(1);
    // Erst hier den mobilen Arbeitsbereich aufbauen: Er macht die Seite zu
    // einem festen Bildschirm und hätte das Schaufenster zerschnitten.
    api.mobilArbeitsbereich();
    api.platziereMusterknopf();
    api.syncLabels();
    // Höhen neu messen — Kaufleiste und Stoffkarten kannten bisher nur die
    // Maße des Schaufensters.
    dispatchEvent(new Event('resize'));
    requestAnimationFrame(() => {
      if (innerWidth <= 989) api.rasteEin();
      else {
        /* Am Schreibtisch nur nach oben nachfassen. Steht der Konfigurator
           schon im Bild, bleibt die Seite stehen — `scrollIntoView` zog ihn
           auch dann an den Seitenanfang und schob die Ansicht vom Seitenkopf
           aus um 137 px nach unten (gemessen). */
        const oben = root.querySelector('.fmnv-p3d__layout')?.getBoundingClientRect().top ?? 0;
        if (oben < 0) scrollBy({ top: oben, behavior: 'smooth' });
      }
      /* Die Zeile des gewählten Stoffs an den Anfang der Liste holen. Ohne
         das steht oben ein anderer Stoff markiert und der gerade am Foto
         gewählte liegt weit unten — es sieht aus, als hätte der Sprung die
         Farbe nicht übernommen.

         Von Hand gerollt, nicht per scrollIntoView: Das rollt alle Vorfahren
         mit und schob die Seite selbst um 396 px nach unten (gemessen) — im
         Konfigurier-Bildschirm ist der Seitenanfang aber die Arbeitsposition.
         Nach der Anfahrt oben, nicht davor. */
      if (c) setTimeout(rolleZuZeile, 420);
    });
  }

  function rolleZuZeile() {
    const roller = root.querySelector('.fmnv-p3d__steps');
    const zeile = root.querySelector('.fmnv-p3d__sf.is-current');
    if (!roller || !zeile) return;
    const versatz = zeile.getBoundingClientRect().top - roller.getBoundingClientRect().top - 8;
    roller.scrollTo({ top: roller.scrollTop + versatz, behavior: 'smooth' });
  }

  function ruesteBedienung() {
    root.querySelectorAll('[data-p3d-sr-nav]').forEach((btn) => {
      btn.addEventListener('click', () => {
        api.melde('konfigurator', 'schaufenster_pfeil', btn.dataset.p3dSrNav);
        zeigeBild(idx + Number(btn.dataset.p3dSrNav));
      });
    });
    root.querySelector('[data-p3d-sr-badge]')?.addEventListener('click', () => {
      if (liste[idx]?.farbe) oeffne(liste[idx].farbe, 'badge');
    });
    root.querySelector('[data-p3d-sr-start]')?.addEventListener('click', () => {
      oeffne(null, 'knopf');
    });

    /* Wischen auf dem Bild blättert. Senkrechte Gesten bleiben der Seite: Ein
       Foto, das beim Scrollen weiterblättert, fühlt sich kaputt an. */
    const buehne = root.querySelector('[data-p3d-sr-buehne]');
    if (!buehne) return;
    let x0 = null, y0 = null;
    buehne.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    buehne.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      api.melde('konfigurator', 'schaufenster_wischen', dx < 0 ? 'weiter' : 'zurueck');
      zeigeBild(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* Mitlaufende Leiste (mobil, Audit 2026-10-05): Unter dem Schaufenster
     folgten rund sieben Bildschirme ohne Preis und ohne Knopf, und auf
     kleinen Handys lag der Knopf schon beim Laden unter dem Rand. Die Leiste
     steht immer dann, wenn der große Knopf nicht im Bild ist — oberhalb wie
     unterhalb. Ist er sichtbar, verschwindet sie, damit es ihn nicht zweimal
     gibt. Geprüft wird beim Scrollen selbst: Ein IntersectionObserver sieht
     einen Sprung über den Knopf hinweg (Anker, scrollTo) nicht.
     Mit dem Öffnen des Konfigurators verschwindet sie; dort hat die
     Kaufleiste ihren Platz. */
  let leiste = null, leistenPruefung = null, leistenGroesse = null;
  function ruesteLeiste() {
    const start = root.querySelector('[data-p3d-sr-start]');
    if (!start || leiste || !matchMedia('(max-width: 989px)').matches) return;
    leiste = document.createElement('div');
    leiste.className = 'fmnv-p3d__sr-leiste';
    leiste.hidden = true;
    const g = api.guenstigsteVariante();
    leiste.innerHTML = '<div class="fmnv-p3d__sr-leiste-preis"><span>ab</span> <b></b></div>'
      + '<button type="button" class="fmnv-p3d__atc fmnv-p3d__sr-leiste-cta">Jetzt konfigurieren</button>';
    leiste.querySelector('b').textContent = g ? api.geld(g.cent) : '';
    // Die Leiste hängt am <body>, außerhalb des Konfigurators — dessen
    // Farbvariablen kommen deshalb nicht von selbst an.
    const cs = getComputedStyle(root);
    ['--p3d-accent', '--p3d-accent-text'].forEach((v) => {
      const wert = cs.getPropertyValue(v).trim();
      if (wert) leiste.style.setProperty(v, wert);
    });
    leiste.querySelector('button').addEventListener('click', () => {
      scrollTo({ top: 0 });
      oeffne(null, 'leiste');
    });
    document.body.appendChild(leiste);
    let geplant = false;
    leistenPruefung = () => {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(() => {
        geplant = false;
        if (!leiste) return;
        const r = start.getBoundingClientRect();
        // Nur ein Knopf, der wirklich zu sehen ist, ersetzt die Leiste —
        // ein angeschnittener Rand am Bildschirmende zählt nicht.
        const imBild = r.bottom > 24 && r.top < innerHeight - 24;
        leiste.hidden = imBild || !root.classList.contains('ist-showroom');
        document.documentElement.classList.toggle('hat-sr-leiste', !leiste.hidden);
      });
    };
    addEventListener('scroll', leistenPruefung, { passive: true });
    addEventListener('resize', leistenPruefung);
    // Nachladende Bilder verschieben den Knopf, ohne dass jemand scrollt.
    if ('ResizeObserver' in window) {
      leistenGroesse = new ResizeObserver(leistenPruefung);
      leistenGroesse.observe(document.body);
    }
    leistenPruefung();
  }
  function schliesseLeiste() {
    if (leistenPruefung) {
      removeEventListener('scroll', leistenPruefung);
      removeEventListener('resize', leistenPruefung);
    }
    leistenGroesse?.disconnect();
    document.documentElement.classList.remove('hat-sr-leiste');
    leiste?.remove();
    leiste = null; leistenPruefung = null; leistenGroesse = null;
  }

  /* Die Zeilen neben dem Knopf. Sie nennen nur, was gezählt werden kann —
     eine erfundene Zahl stünde sonst neben echten Fotos. */
  function texte() {
    const familien = api.bestellbareFamilien();
    const farben = familien.reduce((n, f) => n + f.colors.length, 0);
    const hinweis = root.querySelector('[data-p3d-sr-hinweis]');
    // Die Zahl der Stoffe im Schaufenster steht bewusst nicht daneben: Bei
    // Serien mit Fotos von nur zwei Stoffen liest sie sich als Mangel,
    // obwohl zur Wahl alle stehen.
    if (hinweis) hinweis.textContent = `${farben} Farben in ${familien.length} Stoffen`;
    const preis = root.querySelector('[data-p3d-sr-preis]');
    const g = api.guenstigsteVariante();
    if (preis && g) preis.textContent = api.geld(g.cent);
  }

  return {
    anzahl: anzahlWohnbilder,
    /* Vorn steht die Farbe, die der Konfigurator ohnehin zeigen würde — so
       beginnt die Seite nicht mit einem beliebigen Foto. */
    starte(startCode) {
      if (!liste.length || !srEl) return;
      ruesteBedienung();
      zeichneKacheln();
      texte();
      const start = liste.findIndex((b) => b.code === startCode);
      zeigeBild(start < 0 ? 0 : start, true);
      srEl.hidden = false;
      root.classList.toggle('sr-einzeln', liste.length < 2);
      ruesteLeiste();
    },
  };
}
